import React from 'react';
import styled, { css } from 'styled-components';
import { translate } from '../../../../../common/translation/translate';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

interface WeatherDetailsLoadingUIProps {
    isNight: boolean;
}

export const WeatherDetailsLoadingUI = ({ isNight }: WeatherDetailsLoadingUIProps) => {
    return (
        <Container>
            <DayText>
                {
                    isNight 
                        ? translate('night')
                        : <AnimatedLoadingPlaceholder height='17px' width={39} />
                }
            </DayText>
            <DescriptionText>
                <AnimatedLoadingPlaceholder height='17px' width={59} />
            </DescriptionText>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(100% - 50px - 40px);
    padding-left: 10px;
`;

const WeatherDetailsTextStyles = css`
    display: flex;
    flex-direction: row;
    font-size: 15px;
    font-weight: 600;
    color: #666;
    width: 100%;
    height: 50%;
`;

const DayText = styled.div`
    ${WeatherDetailsTextStyles}
`;

const DescriptionText = styled.div`
    ${WeatherDetailsTextStyles}
    font-size: 13px;
    font-weight: 400;
`;